/* eslint-disable */

xplenty.service('packageVariables', [
  'Variable',
  'notify',

  function (Variable, notify) {
    return {
      defaultVariables: [],

      objectToArrayOfObjects(obj, defaults) {
        const arrayOfObjects = [];

        defaults = angular.isObject(defaults) ? defaults : {};

        for (var key in obj) {
          const variable = {
            key,
            keyDisabled: false,
            hideButtons: false,
            setDefault: false,
            changed: false,
            value: obj[key],
            defaultValue: obj[key],
          };

          arrayOfObjects.push(variable);
        }

        for (var key in defaults) {
          angular.forEach(arrayOfObjects, function (variable) {
            if (variable.key === key) {
              variable.defaultValue = defaults[key];
              variable.changed = defaults[key] != obj[key];
            }
          });
        }

        return arrayOfObjects;
      },

      setFieldsSettings(variables, hideButtons, keyDisabled, setDefault) {
        angular.forEach(variables, function (variable) {
          variable.hideButtons = hideButtons;
          variable.keyDisabled = keyDisabled;
          variable.setDefault = setDefault;
        });
      },

      setDefaults(variablesDefaults) {},

      getDefaultVariables(callback) {
        if (this.defaultVariables.length === 0) {
          const _this = this;

          Variable.get().subscribe(
            function (data) {
              _this.defaultVariables = _this.objectToArrayOfObjects(data);

              callback(_this.defaultVariables);
            },
            function () {
              notify.error(null, 'Failed to load system variables');
            },
          );
        } else {
          callback(this.defaultVariables);
        }
      },

      separateVariables(variables, defaults, callback) {
        const _this = this;

        const variablesObject = {
          userVariables: [],
          systemVariables: [],
        };

        const isSystemVariable = function (variable) {
          let isSystemVariable = false;

          angular.forEach(_this.defaultVariables, function (defaultVariable, index) {
            if (defaultVariable.key == variable.key) {
              isSystemVariable = true;
              variablesObject.systemVariables[index].value = variable.value;
              variablesObject.systemVariables[index].changed = true;
            }
          });

          return isSystemVariable;
        };

        const defineVariable = function (variable) {
          if (!isSystemVariable(variable)) {
            variablesObject.userVariables.push(variable);
          }
        };

        this.getDefaultVariables(function (defaultVariables) {
          variablesObject.systemVariables = angular.copy(defaultVariables);

          const variablesArray = _this.objectToArrayOfObjects(variables || {}, defaults || {});

          angular.forEach(variablesArray, defineVariable);

          callback(variablesObject);
        });
      },

      combineVariables(variablesObject) {
        const _this = this;
        const variables = {};

        const systemDefaultHasChanged = function (systemVariable) {
          let hasChanged = false;

          angular.forEach(_this.defaultVariables, function (defaultVariable) {
            if (defaultVariable.key === systemVariable.key) {
              hasChanged = defaultVariable.value != systemVariable.value;
            }
          });

          return hasChanged;
        };

        angular.forEach(variablesObject.userVariables, function (userVariable) {
          variables[userVariable.key] = userVariable.value;
        });

        angular.forEach(variablesObject.systemVariables, function (systemVariable) {
          if (systemDefaultHasChanged(systemVariable)) {
            variables[systemVariable.key] = systemVariable.value;
          }
        });

        return variables;
      },
    };
  },
]);
